export function calculateRemainingTime(date, time) {
  const formattedTime = `${String(time[0]).padStart(2, "0")}:${String(
    time[1]
  ).padStart(2, "0")}`;

  const scheduleTime = new Date(`${date}T${formattedTime}Z`);
  const now = new Date();
  const diff = scheduleTime - now + 1 * 1000;

  if (diff <= 0) {
    return "Time's up!";
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return `${hours}h ${minutes}m ${seconds}s remaining`;
}
export function remainingTimeCheck(timeString) {
  const timeParts = timeString.match(/(\d+)h (\d+)m (\d+)s/);
  if (timeParts) {
    const hours = parseInt(timeParts[1], 10);
    const minutes = parseInt(timeParts[2], 10);
    const seconds = parseInt(timeParts[3], 10);
    return hours * 3600 + minutes * 60 + seconds; // Total seconds remaining
  }
  return 0;
}